/* eslint-disable no-empty-pattern */
/* eslint-disable react/prop-types */
import { makeStyles, Tooltip } from "@material-ui/core";
import React from "react";
// import { HiOutlineDotsVertical } from "react-icons/hi";
import { nFormatter } from "lib/utils";
import ScenarioOptions from "./ScenarioOptions";
import ScenariosDropdownSummary from "../scenarios-dropdown/ScenariosDropdownSummary";

const myStyles = makeStyles((theme) => ({
  scenarioCard: {
    boxSizing: "border-box",
    width: "100%",
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    display: "flex",
    flexDirection: "column",
    border: "1px solid rgba(0, 0, 0, 0.2)",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
    borderRadius: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
    height: "100%", // 👈 importante para estirar
  },
  emptyScenarioCard: {
    boxSizing: "border-box",
    width: "100%",
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "2px dotted rgba(0, 0, 0, 0.2)",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
    borderRadius: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
    height: "100%", // 👈 también aquí
  },
  header: {
    boxSizing: "border-box",
    flexGrow: "1",
    flexShrink: "0",
    flexBasis: "0",
    color: "white",
    display: "flex",
    backgroundColor: theme.palette.primary.main,
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "5px 5px 0 0",
    height: "45px",
    padding: "5px 10px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  title: {
    boxSizing: "border-box",
    maxWidth: "90%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "inherit",
    fontFamily: "inherit",
    cursor: "default",
    [theme.breakpoints.up(2560)]: { fontSize: "19px" },
    [theme.breakpoints.between(1920, 2560)]: { fontSize: "17px" },
    [theme.breakpoints.between(1440, 1920)]: { fontSize: "15px" },
    [theme.breakpoints.between(1280, 1440)]: { fontSize: "14px" },
    [theme.breakpoints.down(1280)]: { fontSize: "14px" },
  },
  titleTooltip: {
    padding: "10px 10px",
    [theme.breakpoints.up(2560)]: { fontSize: "16px" },
    [theme.breakpoints.between(1920, 2560)]: { fontSize: "14.5px" },
    [theme.breakpoints.between(1440, 1920)]: { fontSize: "13px" },
    [theme.breakpoints.between(1280, 1440)]: { fontSize: "12px" },
    [theme.breakpoints.down(1280)]: { fontSize: "12px" },
  },
  kpis: {
    flexGrow: "3",
    flexShrink: "0",
    flexBasis: "0",
    boxSizing: "border-box",
    background: "white",
    padding: "5px 15px",
    gap: "5px",
    width: "100%",
    height: "100%",
    borderRadius: "0 0 5px 5px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  kpi: {
    boxSizing: "border-box",
    display: "flex",
    // width: "100%",
    // gap: "10px",
    justifyContent: "space-between",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  kpiItems: {
    boxSizing: "border-box",
    fontSize: "inherit",
    fontFamily: "inherit",
    // flex: "0 0 auto",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
    // "&:nth-child(2)": { textAlign: "right" },
  },
}));

const ScenarioSelectorCard = ({
  scenarioId,
  scenarioName,
  sellOut,
  salesOut,
  margin,
  priceOut,
  // retailerMargin,
}) => {
  const classes = myStyles();

  if (!scenarioId) {
    return (
      <ScenariosDropdownSummary useAsButton>
        <div className={classes.emptyScenarioCard}>
          Add a scenario to compare
        </div>
      </ScenariosDropdownSummary>
    );
  }
  return (
    <div className={classes.scenarioCard}>
      <Tooltip
        title={<div className={classes.titleTooltip}>{scenarioName}</div>}
        placement="top-start"
      >
        <div className={classes.header}>
          <div className={classes.title}>{scenarioName}</div>
          <ScenarioOptions scenarioId={scenarioId} />
        </div>
      </Tooltip>

      <div className={classes.kpis}>
        <div className={classes.kpi}>
          <div className={classes.kpiItems}>Sell Out</div>
          <div className={classes.kpiItems}>{`${nFormatter(
            sellOut
          )} Pieces`}</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiItems}>Sales Out</div>
          <div className={classes.kpiItems}>{`$${nFormatter(salesOut)}`}</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiItems}>Margin</div>
          <div className={classes.kpiItems}>{`$${nFormatter(margin)}`}</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiItems}>Price Out</div>
          <div className={classes.kpiItems}>{`$${nFormatter(priceOut)}`}</div>
        </div>
        {/* <div className={classes.kpi}>
          <div className={classes.kpiItems}>Retailer Margin</div>
          <div className={classes.kpiItems}>{retailerMargin}</div>
        </div>  */}
      </div>
    </div>
  );
};

export default ScenarioSelectorCard;
